import React from "react";
import { bool, string } from "prop-types";

function ProfileBadge({ image, inHeader, height, width }) {
  if (image && image !== 'null') {
    debugger
    return (
      <img
        alt="Foto de perfil"
        src={image}
        className={`${inHeader ? 'profile-image' : ''}`}
        height={height}
        width={width}
      />
    );
  }
  else {
    return <i class="counter-icon fa fa-user-circle" aria-hidden="true"></i>
  }
}

ProfileBadge.propTypes = {
  image: string,
  height: string,
  width: string,
  inHeader: bool,
};

ProfileBadge.defaultProps = {
  image: '',
  height: 35,
  width: 35,
  inHeader: false,
};

export default ProfileBadge;
